import React from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";

import { useAuth0 } from "@auth0/auth0-react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  ContactSupportOutlined,
  PowerSettingsNew,
  Settings,
} from "@material-ui/icons";

import { SupportDialog } from "@ip-partials";
import { appActions, userActions } from "@ip-store/actions";
import { capitalizeText, publicPath } from "@ip-utils";

const useStyles = makeStyles((theme) => ({
  user: {
    backgroundColor: theme.palette.iglu.denimBlue,
    color: theme.palette.common.white,
    padding: "5px 15px",
    "&:hover": {
      backgroundColor: theme.palette.common.white10,
    },
  },
}));

function User({ user, appActions, userActions }) {
  const { logout } = useAuth0();

  const [anchor, setAnchor] = React.useState(null);
  const classes = useStyles();

  function handleOpen(e) {
    setAnchor(e.currentTarget);
  }

  function handleClose() {
    setAnchor(null);
  }

  function handleWiki() {
    window.open(process.env.REACT_APP_WIKI_URL, "_blank");
  }

  function handleLogout() {
    userActions.logout();
    logout({ returnTo: window.location.origin });
  }

  const supportButton = (
    <MenuItem onClick={handleClose}>
      <ListItemIcon>
        <ContactSupportOutlined fontSize="small" />
      </ListItemIcon>
      <Typography variant="inherit">Contact Support</Typography>
    </MenuItem>
  );

  return (
    <Box marginLeft={1}>
      <Button className={classes.user} onClick={handleOpen}>
        {user.isLoading ? (
          <Box
            alignItems="center"
            display="flex"
            height={22}
            marginLeft={-0.5}
            marginRight={-0.5}
          >
            <CircularProgress size="1em" />
          </Box>
        ) : (
          capitalizeText(user.name[0])
        )}
      </Button>
      <Menu
        anchorEl={anchor}
        keepMounted
        open={!!anchor}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {process.env.REACT_APP_WIKI_URL && (
          <MenuItem onClick={handleWiki}>
            <ListItemIcon>
              <img
                alt="Wiki"
                src={publicPath("/media/wiki-black.svg")}
                width={20}
                height={20}
              />
            </ListItemIcon>
            <Typography variant="inherit">Wiki</Typography>
          </MenuItem>
        )}
        <SupportDialog button={supportButton} />
        <Link to="/settings">
          <Divider />
          <MenuItem>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">Settings</Typography>
          </MenuItem>
        </Link>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <PowerSettingsNew fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">Sign Out</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
}

const mapStateToProps = (store) => ({
  user: store.user,
});

const mapDispatchToProps = (dispatch) => ({
  userActions: bindActionCreators(userActions, dispatch),
  appActions: bindActionCreators(appActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(User);
